/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'chevron': {
    width: 102,
    height: 53,
    viewBox: '0 0 102 53',
    data: '<path pid="0" d="M1 52L51 2l50 50" fill-rule="nonzero" _stroke="currentColor" stroke-width="2" _fill="none"/>'
  }
})
